module.exports = __webpack_public_path__ + "static/img/guide_1_1_1.73b7dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_1_1_1.jpg
// module id = qwh6
// module chunks = 1